import { Card } from "@mui/material";
import { Cols } from "../../shared/Consts";
import Holding from "../../models/Holding";
import KeyVal from "../../components/KeyVal";

export default function SummaryFixed(props:{holding:Holding}) {
    return <Card className="historySummary">
        <KeyVal label="Total" value={props.holding.value(Cols.holdingValue)}/>
        <KeyVal label="Dividend" value={props.holding.value(Cols.dividend)}/>
    </Card>
}
